module.exports = __webpack_public_path__ + "img/4-1.8569750c.png";